import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatRoomDetailsSidebarComponent } from './chat-room-details-sidebar.component';
import { ManageMembersModalComponent } from './manage-members-modal/manage-members-modal.component';
import { SharedModule } from '@shared/shared.module';
import { InteractionModule } from '@app/interaction/interaction.module';
// Note: ResolutionCenterService is provided in root, so we don't need to import ResolutionCenterModule

/**
 * Standalone ChatRoomDetailsSidebarModule
 * Can be imported into any module without routing conflicts
 */
@NgModule({
    declarations: [ChatRoomDetailsSidebarComponent, ManageMembersModalComponent],
    imports: [
        CommonModule,
        SharedModule,
        InteractionModule
    ],
    exports: [ChatRoomDetailsSidebarComponent, ManageMembersModalComponent]
})
export class ChatRoomDetailsSidebarModule { }

